import React from 'react';
import { ButtonsContainer, Modal } from '@forma/forma-ui-kit';
import SocialModal from '@/components/SocialModal';

import styles from './connect-us-modal.module.css';

const tgUrl = process.env.TG_CONTACT_URL;
const maxUrl = process.env.MAX_URL;
// const waUrl = process.env.WA_URL;

interface ConnectUsModalProps {
  title?: React.ReactNode;
  subtitle?: React.ReactNode;
  control: React.ReactElement;
}

const ConnectUsModal = ({ title, subtitle, control }: ConnectUsModalProps) => {
  return (
    <Modal
      control={control}
      width="516px"
      title={title ?? 'Покажем за 7-10 минут как работает функция'}
      titleClassName={styles.modalTitle}
    >
      <div className={styles.description}>
        {subtitle ?? 'Напишите в один из наших мессенджеров и мы покажем, как работает данная функция, а также поможем её настроить и ответим на вопросы'}
      </div>
      <ButtonsContainer className={styles.buttons}>
        <SocialModal
          viewStyle="primary"
          name="Telegram"
          icon="/icons/social/telegram.svg"
          link={tgUrl!}
        />
        {/*<SocialModal
          viewStyle="secondary"
          name="WhatsApp"
          icon="/icons/social/whatsapp.svg"
          link={waUrl!}
          qr="/images/qr-whatsapp.png"
        />*/}
        <SocialModal
          viewStyle="secondary"
          name="Max"
          icon="/icons/social/max.svg"
          link={maxUrl!}
        />
      </ButtonsContainer>
    </Modal>
  );
};

export default ConnectUsModal;
